import { defineMessages } from 'react-intl';

export default defineMessages({
  connectStore: {
    description: 'Onboarding Modal > Connect Store > Label',
    defaultMessage: 'Follow the steps to Reauthenticate:',
    id: 'QbCgWR',
  },
  cancel: {
    description: 'Cancel Button Message',
    defaultMessage: 'Cancel',
    id: 'W1U/rf',
  },
  authenticate: {
    description: 'Onboarding Heading',
    defaultMessage: 'Authenticate',
    id: '1zWT6/',
  },
  authenticationError: {
    description: 'Authentication Error',
    defaultMessage: 'An error occurred while authenticating the store. Please try again later.',
    id: 'wATGxo',
  },
  toReauthenticate: {
    description: 'Authenticate With Marketplace Modal > Label',
    defaultMessage: 'To reauthenticate:',
    id: 'DMycZg',
  },
  toReauthenticateStep1: {
    description: 'Authenticate With Marketplace Modal > Step 1',
    defaultMessage: 'Click <b>Reauthenticate</b> to sign in to your Shopify account.',
    id: 'vKYUn4',
  },
  toReauthenticateStep2: {
    description: 'Authenticate With Marketplace Modal > Step 2',
    defaultMessage: 'Click <b>Install App</b> to grant permissions for order access and updates.',
    id: 'pYBP91',
  },
  toReauthenticateStep3: {
    description: 'Authenticate With Marketplace Modal > Step 3',
    defaultMessage: "Once installed, you'll be returned to ShipStation to complete your setup.",
    id: 'ueZe9/',
  },
  storeLabel: {
    description: 'Shopify Auth Page > Shopify Name Label',
    defaultMessage: '{marketplaceName} Store:',
    id: '0tvKlg',
  },
  shopifyAdditionalInfoHeader: {
    description: 'Shopify Auth Page > Additional Info Header',
    defaultMessage: 'Why do I need to do this?',
    id: 'Kaxq6d',
  },
  shopifyAdditionalInfo1: {
    description: 'Shopify Auth Page > Expanded Additional Info 1',
    defaultMessage: 'ShipStation needs some additional permissions to process returns for Shopify orders.',
    id: 'bI+LIK',
  },
  shopifyAdditionalInfo2: {
    description: 'Shopify Auth Page > Expanded Additional Info 2',
    defaultMessage: 'Installing the returns app allows you to issue refunds and create exchange orders via ShipStation.',
    id: 'CJNG8S',
  },
  shopifyAdditionalInfo3: {
    description: 'Shopify Auth Page > Expanded Additional Info 3',
    defaultMessage: 'With the returns app, you can create a branded returns and exchange experience for your customers.',
    id: 'GZqiqn',
  },
});
